import { useTranslation } from "react-i18next";

export default function Process({
  anchor = true,
  showTitle = true,
  className = "",
  maxSteps, // optional: limit how many steps to show (e.g., 4 for home teaser)
}) {
  const { t } = useTranslation();

  const sectionProps = {
    className: `py-16 ${className}`.trim(),
    ...(anchor ? { id: "process" } : {}),
  };

  // Pull the whole array from i18n; works with any length (4, 6, 8, …)
  let steps = t("process.steps", { returnObjects: true }) || [];
  if (!Array.isArray(steps)) steps = [];
  if (typeof maxSteps === "number") steps = steps.slice(0, maxSteps);

  return (
    <section {...sectionProps}>
      <div className="mx-auto max-w-7xl px-4">
        {showTitle && (
          <>
            <h2 className="text-3xl font-bold">{t("process.heading")}</h2>
            <p className="mt-2 text-slate-600">{t("process.subheading")}</p>
          </>
        )}

        <ol className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {steps.map((s, i) => (
            <li
              key={`${i}-${s?.title || "step"}`}
              className="rounded-2xl border border-slate-200 p-6 bg-white hover:shadow-sm transition"
            >
              <div className="h-10 w-10 grid place-content-center rounded-full bg-indigo-600 text-white font-bold">
                {i + 1}
              </div>
              <h3 className="mt-4 font-semibold">{s?.title}</h3>
              <p className="mt-2 text-sm text-slate-600">{s?.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
